<template>
    <div class="ut-mt-8">
        <h2 class="ut-px-6 ut-text-xs ut-tracking-wide ut-text-neutral-001 ut-opacity-25" v-text="name">
        </h2>
        <ul>
            <slot></slot>
        </ul>
    </div>
</template>
<script>
export default {
  name: 'side-nav-category',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>

    h2 {
        line-height: 32px;
    }

    ul {
        li {
            @apply ut-text-neutral-001 ut-py-2 ut-px-6 ut-opacity-75 ut-inline-block ut-w-full;
            cursor: pointer;
            letter-spacing: 0.3px;
            line-height: 24px;

            &.active {
                @apply ut-opacity-100;
                background-color: #363636;

                &:after {
                    border-left: 10px solid #363636;
                    border-top: 20px solid transparent;
                    border-bottom: 20px solid transparent;
                    content: " ";
                    position: absolute;
                    right: -10px;
                    margin-top: -8px;
                }
            }
        }
    }

</style>
